function _generateDeviceID() {
	const deviceIDLen = 25
	const alphabet = "abcdefghijklmnopqrstuvwxyz1234567890"

	var ret = ""

	for (var i = 0; i < deviceIDLen; i++) { 
		ret += alphabet[Math.floor(Math.random() * alphabet.length)]; 
	}

	return ret; 
}

export default {
	getDeviceID() {
		var ret = localStorage.getItem("deviceID")
		if (ret === null) {
			ret = _generateDeviceID()
			localStorage.setItem("deviceID", ret)
		}
		return ret
	},
	getAppVersion() {
		return "0.9.16"
	}
}
